import Logo from "@/assets/logo.svg?react";

export const PoweredByMixinRoute = () => (
  <footer className="text-3 pb+safe-2 md:op-0 flex items-center justify-center pt-4 text-zinc-500 dark:text-[#8B93A3]">
    Powered by
    <Logo width={12} height={12} className="mx-1 fill-black dark:fill-[#8B93A3]" />
    Mixin Route
  </footer>
);
